export const cedulas_item = [
  /*   {
      
        "url": "/assets/imgs/CEDULA_COORDINACION.jpg",
        "icono": "COORDINACION.png",
        "id": "Coordinación General de la Oficialía Mayor"
    },
    {
      
        "url": "/assets/imgs/CEDULA_JURIDICO.jpg",
        "icono": "JURIDICO.png",
        "id": "Dirección General de Asuntos Jurídicos"
    },
     */
    {
        
        "url": "/assets/imgs/CEDULA_ADMON.jpg",
        "icono": "ADMON.png",
        "id": "Dirección General de Administración",
       
    },
    {
       
        "url": "/assets/imgs/CEDULA_ARCHIVO.jpg",
        "icono": "ARCHIVO.png",
        "id": "Archivo General del Estado de Hidalgo"
    },
    {
        
        "url": "/assets/imgs/CEDULA_PATRIMONIO.jpg",
        "icono": "PATRIMONIO.png" ,
        "id": "Dirección General de Patrimonio Inmobiliario"
    },
    {
       
        "url": "/assets/imgs/CEDULA_MATERIALES.jpg",
        "icono": "MATERIALES.png",
        "id": "Dirección General de Recursos Materiales"
    },
    {
       
        "url": "/assets/imgs/CEDULA_SERVICIOS.jpg",
        "icono": "SERVICIOS.png",
        "id": "Dirección General de Servicios Generales"
    },
    {
       
        "url": "/assets/imgs/CEDULA_PERSONAL.jpg",
        "icono": "PERSONAL.png" ,
        "id": "Dirección General de Recursos Humanos"
    },
    {
      
        "url": "/assets/imgs/CEDULA_COMPRAS.jpg",
        "icono": "COMPRAS.png",
        "id": "Dirección General de Compras Públicas"
    },
    {
      
        "url": "/assets/imgs/CEDULA_INNOVACION.jpg",
        "icono": "INNOVACION.png",
        "id": "Dirección General de Innovación Gubernamental"
    },
     
   

]